/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 */

export const SET_PRICE_DATA_RECENT_AVERAGES = '@@nzr/priceData/SET_PRICE_DATA_RECENT_AVERAGES'
export const SET_PRICE_DATA_YOY_CHANGE = '@@nzr/priceData/SET_PRICE_DATA_YOY_CHANGE'
